import { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";

import type { LandingLang } from "./constants";

// The page language, fixed by the route: pre-render and hydration must read the same copy.
export const LandingLangContext = createContext<LandingLang>("en");

export function useLandingLang(): LandingLang {
  return useContext(LandingLangContext);
}

// A t() pinned to the page language, independent of the i18n singleton's current language.
export function useLandingTranslation() {
  return useTranslation("landing", { lng: useLandingLang() });
}
